import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api_url from '../config/api_url';

function ProtectedRoute({ element }) {
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        const getCookie = (name) => document.cookie.split(';').map(c => c.trim()).find(c => c.startsWith(name + '='))?.split('=')[1];
        const email = getCookie('email');
        const session_token = getCookie('session_token');

        if (!email || !session_token) {
            setStatus('denied');
            return;
        }

        fetch(api_url + '/api/user/verify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user: { email, session_token } })
        })
            .then(res => setStatus(res.ok ? 'allowed' : 'denied'))
            .catch(() => setStatus('denied'));
    }, []);

    if (status === 'loading') return null;
    if (status === 'allowed') return element;
    return <Navigate to="/login" />;
}

export default ProtectedRoute;
